import { render, staticRenderFns } from "./goods-list-item.vue?vue&type=template&id=05ad48e8&scoped=true"
import script from "./goods-list-item.vue?vue&type=script&lang=js"
export * from "./goods-list-item.vue?vue&type=script&lang=js"
import style0 from "./goods-list-item.vue?vue&type=style&index=0&id=05ad48e8&prod&lang=css"
import style1 from "./goods-list-item.vue?vue&type=style&index=1&id=05ad48e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad48e8",
  null
  
)

export default component.exports